import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useResponsiveBreakpoints } from '../../../../hooks/useResponsiveBreakpoints';

import StageProgress from '../StageProgress/StageProgress';
import { Badge, Button } from '../../../../design-system';
import { ArrowGoBackLineIcon } from '../../../../design-system/Icons';

const CycleDetailHeader = ({ name, stage, backLinkHref }) => {
    const { progress, stage_status } = stage || {};
    const { status_label, status_color } = stage_status || {};

    const navigate = useNavigate();

    const { isDesktop } = useResponsiveBreakpoints();

    return (
        <div className="w-full px-4 xs:px-5 md:px-6 py-5 md:py-6 lg:p-0 flex flex-col gap-4 lg:gap-5 bg-neutral-50 lg:bg-white">
            <div className="flex items-center gap-5">
                <Button
                    type="link"
                    size={isDesktop ? 'sm' : 'xs'}
                    text="Back"
                    leadingIcon={ArrowGoBackLineIcon}
                    onClick={() => navigate(backLinkHref)}
                />

                {!isDesktop && (
                    <p className="font-body text-body-regular-s text-neutral-300">CRAFT Cycles /</p>
                )}
            </div>

            <h1 className="font-heading-bold text-heading-bold-m md:text-heading-bold-l text-black">
                {name}
            </h1>

            {!isDesktop && (
                <div className="w-full px-4 py-2.5 flex items-center justify-between gap-4 md:gap-8 rounded-2 bg-white">
                    <div className="flex-grow min-w-[170px]">
                        <StageProgress name={stage.name} progress={progress} gapY={4} gapX={8} />
                    </div>

                    <div className="overflow-hidden">
                        <Badge text={status_label} color={status_color} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default CycleDetailHeader;
